export const STATUS_UNINITIALIZED = 'uninitialized';
export const STATUS_LOADING = 'loading';
export const STATUS_READY = 'ready';
export const STATUS_ERROR = 'error';
